'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	contextAttributeValue = function (domElement, attributeName, context) {
		const contextProp = domElement.getAttribute(attributeName),
			equalityComponents = contextProp && contextProp.split && contextProp.split('=='),
			inequalityComponents = contextProp && contextProp.split && contextProp.split('!=');
		if (equalityComponents && equalityComponents.length === 2) {
			return (context && context[equalityComponents[0]] === equalityComponents[1]);
		}

		if (inequalityComponents && inequalityComponents.length === 2) {
			return (!context || !context[inequalityComponents[0]] || context[inequalityComponents[0]] !== inequalityComponents[1]);
		}

		if (contextProp && contextProp[0] === '!') {
			return !context || !context[contextProp.substring(1)];
		} else {
			return context && context[contextProp];
		}

	};

mmWidgets.fn.contextDisablerWidget = function (observable, eventName, attributeName) {
	return mmWidgets.each(this, function () {
		const element = this,
			updateForContext = function (context) {
				element.domElements.forEach(domElement => {
					const contextVal = contextAttributeValue(domElement, attributeName, context);
					if (!contextVal) {
						domElement.classList.add('disabled');
					} else {
						domElement.classList.remove('disabled');
					}
				});
			};
		observable.addEventListener(eventName, updateForContext);
	});
};
